import httpManager from "@/app/shared/utils/httpManager";

export default async function () {
  return await httpManager.get(`/forms/`);
}
